
import './App.css';
import { Header } from './Header';
import { Services } from './Services';
import { Contact } from './Contact';
import { Home } from './Home';
import { FinalCall } from './FinalCall';



function App() {
  return (
  <>
  
    <Header />
    <Home />
    <Services />
    <Contact />
    <FinalCall />
 

  </>
  )
}

export default App;
